module.exports = __webpack_public_path__ + "img/img-09.e039faf0.jpg";